import {CertificateData} from "./certificateData";

export class AdditionalCertificateData {
  certificates: CertificateData[] = [];
}
